/**
 * Labstep
 *
 * @module components/Tag/EmptyState
 * @desc Empty state for tag
 */

import { TagActionCreate } from 'labstep-web/components/Tag/Action/Create';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { ITagEmptyStateProps } from './types';

export const TagEmptyState: React.FC<ITagEmptyStateProps> = ({
  type,
}) => (
  <CardEmptyState
    src="/img/empty-state/files.svg"
    title="No Tags"
    explanation="Use tags to organise the content within your workspace. Tags can be used to differentiate projects, custom statuses, or research areas. Filter by tags when searching for content. "
    action={<TagActionCreate defaultType={type} />}
  />
);
